import React, { type CSSProperties, type ImgHTMLAttributes } from 'react';

// Static imports for Large PNG images
import FallbackHaulTruckImageLarge from 'assets/vehicles/large/fallback-haul-truck.png';
import FallbackLoaderImageLarge from 'assets/vehicles/large/fallback-loader.png';
import CAT777HaulTruckImageLarge from 'assets/vehicles/large/cat-777-haul-truck.png';
import CAT740HaulTruckImageLarge from 'assets/vehicles/large/cat-740-haul-truck.png';
import CAT745CHaulTruckImageLarge from 'assets/vehicles/large/cat-745c-haul-truck.png';
import CAT795FHaulTruckImageLarge from 'assets/vehicles/large/cat-795f-haul-truck.png';
import CAT775GHaulTruckImageLarge from 'assets/vehicles/large/cat-775g-haul-truck.png';
import CAT777FHaulTruckImageLarge from 'assets/vehicles/large/cat-777f-haul-truck.png';
import CAT793FHaulTruckImageLarge from 'assets/vehicles/large/cat-793f-haul-truck.png';
import KomatsuHD15007HaulTruckImageLarge from 'assets/vehicles/large/komatsu-hd1500-7-haul-truck.png';
import KomatsuHD465HaulTruckImageLarge from 'assets/vehicles/large/komatsu-hd465-haul-truck.png';
import CATAD30HaulTruckImageLarge from 'assets/vehicles/large/cat-ad30-haul-truck.png';
import SandvikTH320HaulTruckImageLarge from 'assets/vehicles/large/sandvik-th320-haul-truck.png';
import HitachiE1700FHaulTruckImageLarge from 'assets/vehicles/large/hitachi-eh1700-haul-truck.png';
import CAT798ACHaulTruckImageLarge from 'assets/vehicles/large/cat-798-haul-truck.png';
import CAT972LoaderImageLarge from 'assets/vehicles/large/cat-972-loader.png';
import CAT992GLoaderImageLarge from 'assets/vehicles/large/cat-992g-loader.png';
import CAT992KLoaderImageLarge from 'assets/vehicles/large/cat-992k-loader.png';
import CAT980LoaderImageLarge from 'assets/vehicles/large/cat-980h-loader.png';
import CAT980HLoaderImageLarge from 'assets/vehicles/large/cat-980-loader.png';
import CAT990LoaderImageLarge from 'assets/vehicles/large/cat-990-loader.png';
import CAT993LoaderImageLarge from 'assets/vehicles/large/cat-993-loader.png';
import CATR1700LoaderImageLarge from 'assets/vehicles/large/cat-r1700-loader.png';
import SandvikLH410LoaderImageLarge from 'assets/vehicles/large/sandvik-lh410-loader.png';
import SandvikLH411LoaderImageLarge from 'assets/vehicles/large/sandvik-lh411-loader.png';
import SandvikLH207LoaderImageLarge from 'assets/vehicles/large/sandvik-lh207-loader.png';
import SandvikLH514LoaderImageLarge from 'assets/vehicles/large/sandvik-lh514-loader.png';
import CATR2900LoaderImageLarge from 'assets/vehicles/large/cat-r2900-loader.png';
import CATR1600HLoaderImageLarge from 'assets/vehicles/large/cat-r1600h-loader.png';
import CAT980MLightTruckImageLarge from 'assets/vehicles/large/cat-980m-light-truck.png';
import RokionR100LightTruckImageLarge from 'assets/vehicles/large/rokion-r100-light-truck.png';
import CAT16MMiscellaneousImageLarge from 'assets/vehicles/large/cat-16m-miscellaneous.png';
import CAT24MMiscellaneousImageLarge from 'assets/vehicles/large/cat-24m-miscellaneous.png';
import CAT844HDozerImageLarge from 'assets/vehicles/large/cat-844h-dozer.png';
import CATD10TDozerImageLarge from 'assets/vehicles/large/cat-d10-dozer.png';
import CATD11TDozerImageLarge from 'assets/vehicles/large/cat-d11-dozer.png';
import CAT395ExcavatorImageLarge from 'assets/vehicles/large/cat-395-excavator.png';
import CAT390ExcavatorImageLarge from 'assets/vehicles/large/cat-390-excavator.png';
import AtlasAirrocD45DrillImageLarge from 'assets/vehicles/large/atlas-airrocd45-drill.png';
import AtlasAirrocD65DrillImageLarge from 'assets/vehicles/large/atlas-airrocd65-drill.png';
import SandvikDS311DrillImageLarge from 'assets/vehicles/large/sandvik-ds311-drill.png';
import DTHJK860DrillImageLarge from 'assets/vehicles/large/dth-jk860-drill.png';
import SanySKT115SHaulTruckImageLarge from 'assets/vehicles/large/sany-skt115s-haul-truck.png';
import HitachiEX1200LoaderImageLarge from 'assets/vehicles/large/hitachi-ex1200-loader.png';
import SanySTG265C10GraderImageLarge from 'assets/vehicles/large/sany-stg265c-10-grader.png';
import SEM823FDozerImageLarge from 'assets/vehicles/large/sem-823f-dozer.png';

// Static imports for Small PNG images
import FallbackHaulTruckImageSmall from 'assets/vehicles/small/fallback-haul-truck.png';
import FallbackLoaderImageSmall from 'assets/vehicles/small/fallback-loader.png';
import CAT777HaulTruckImageSmall from 'assets/vehicles/small/cat-777-haul-truck.png';
import CAT740HaulTruckImageSmall from 'assets/vehicles/small/cat-740-haul-truck.png';
import CAT745CHaulTruckImageSmall from 'assets/vehicles/small/cat-745c-haul-truck.png';
import CAT795FHaulTruckImageSmall from 'assets/vehicles/small/cat-795f-haul-truck.png';
import CAT775GHaulTruckImageSmall from 'assets/vehicles/small/cat-775g-haul-truck.png';
import CAT777FHaulTruckImageSmall from 'assets/vehicles/small/cat-777f-haul-truck.png';
import CAT793FHaulTruckImageSmall from 'assets/vehicles/small/cat-793f-haul-truck.png';
import KomatsuHD15007HaulTruckImageSmall from 'assets/vehicles/small/komatsu-hd1500-7-haul-truck.png';
import KomatsuHD465HaulTruckImageSmall from 'assets/vehicles/small/komatsu-hd465-haul-truck.png';
import SandvikTH320HaulTruckImageSmall from 'assets/vehicles/small/sandvik-th320-haul-truck.png';
import HitachiE1700FHaulTruckImageSmall from 'assets/vehicles/small/hitachi-eh1700-haul-truck.png';
import CATAD30HaulTruckImageSmall from 'assets/vehicles/small/cat-ad30-haul-truck.png';
import CAT798ACHaulTruckImageSmall from 'assets/vehicles/small/cat-798-haul-truck.png';
import CAT972LoaderImageSmall from 'assets/vehicles/small/cat-972-loader.png';
import CAT992GLoaderImageSmall from 'assets/vehicles/small/cat-992g-loader.png';
import CAT992KLoaderImageSmall from 'assets/vehicles/small/cat-992k-loader.png';
import CAT980LoaderImageSmall from 'assets/vehicles/small/cat-980h-loader.png';
import CAT980HLoaderImageSmall from 'assets/vehicles/small/cat-980-loader.png';
import CAT990LoaderImageSmall from 'assets/vehicles/small/cat-990-loader.png';
import CAT993LoaderImageSmall from 'assets/vehicles/small/cat-993-loader.png';
import CATR1700LoaderImageSmall from 'assets/vehicles/small/cat-r1700-loader.png';
import SandvikLH410LoaderImageSmall from 'assets/vehicles/small/sandvik-lh410-loader.png';
import SandvikLH411LoaderImageSmall from 'assets/vehicles/small/sandvik-lh411-loader.png';
import SandvikLH207LoaderImageSmall from 'assets/vehicles/small/sandvik-lh207-loader.png';
import SandvikLH514LoaderImageSmall from 'assets/vehicles/small/sandvik-lh514-loader.png';
import CATR2900LoaderImageSmall from 'assets/vehicles/small/cat-r2900-loader.png';
import CATR1600HLoaderImageSmall from 'assets/vehicles/small/cat-r1600h-loader.png';
import CAT980MLightTruckImageSmall from 'assets/vehicles/small/cat-980m-light-truck.png';
import RokionR100LightTruckImageSmall from 'assets/vehicles/small/rokion-r100-light-truck.png';
import CAT16MMiscellaneousImageSmall from 'assets/vehicles/small/cat-16m-miscellaneous.png';
import CAT24MMiscellaneousImageSmall from 'assets/vehicles/small/cat-24m-miscellaneous.png';
import CAT844HDozerImageSmall from 'assets/vehicles/small/cat-844h-dozer.png';
import CATD10TDozerImageSmall from 'assets/vehicles/small/cat-d10-dozer.png';
import CATD11TDozerImageSmall from 'assets/vehicles/small/cat-d11-dozer.png';
import CAT395ExcavatorImageSmall from 'assets/vehicles/small/cat-395-excavator.png';
import CAT390ExcavatorImageSmall from 'assets/vehicles/small/cat-390-excavator.png';
import AtlasAirrocD45DrillImageSmall from 'assets/vehicles/small/atlas-airrocd45-drill.png';
import AtlasAirrocD65DrillImageSmall from 'assets/vehicles/small/atlas-airrocd65-drill.png';
import SandvikDS311DrillImageSmall from 'assets/vehicles/small/sandvik-ds311-drill.png';
import DTHJK860DrillImageSmall from 'assets/vehicles/small/dth-jk860-drill.png';
import SanySKT115SHaulTruckImageSmall from 'assets/vehicles/small/sany-skt115s-haul-truck.png';
import HitachiEX1200LoaderImageSmall from 'assets/vehicles/small/hitachi-ex1200-loader.png';
import SanySTG265C10GraderImageSmall from 'assets/vehicles/small/sany-stg265c-10-grader.png';
import SEM823FDozerImageSmall from 'assets/vehicles/small/sem-823f-dozer.png';

// Map of image names to imported PNG assets
export const images: Record<string, string> = {
  // large PNGs
  fallbackhaul_truckImageLarge: FallbackHaulTruckImageLarge,
  fallbackloaderImageLarge: FallbackLoaderImageLarge,
  cat777haul_truckImageLarge: CAT777HaulTruckImageLarge,
  'hitachieh 1700haul_truckImageLarge': HitachiE1700FHaulTruckImageLarge,
  cat740haul_truckImageLarge: CAT740HaulTruckImageLarge,
  cat745chaul_truckImageLarge: CAT745CHaulTruckImageLarge,
  cat795fhaul_truckImageLarge: CAT795FHaulTruckImageLarge,
  cat775ghaul_truckImageLarge: CAT775GHaulTruckImageLarge,
  cat777fhaul_truckImageLarge: CAT777FHaulTruckImageLarge,
  cat793fhaul_truckImageLarge: CAT793FHaulTruckImageLarge,
  'komatsuhd 1500-7haul_truckImageLarge': KomatsuHD15007HaulTruckImageLarge,
  'komatsuhd 465haul_truckImageLarge': KomatsuHD465HaulTruckImageLarge,
  'sandvikth-320haul_truckImageLarge': SandvikTH320HaulTruckImageLarge,
  catad30haul_truckImageLarge: CATAD30HaulTruckImageLarge,
  cat798achaul_truckImageLarge: CAT798ACHaulTruckImageLarge,
  cat972loaderImageLarge: CAT972LoaderImageLarge,
  cat992gloaderImageLarge: CAT992GLoaderImageLarge,
  cat992kloaderImageLarge: CAT992KLoaderImageLarge,
  cat980hloaderImageLarge: CAT980HLoaderImageLarge,
  cat980loaderImageLarge: CAT980LoaderImageLarge,
  cat990loaderImageLarge: CAT990LoaderImageLarge,
  cat993loaderImageLarge: CAT993LoaderImageLarge,
  catr1700loaderImageLarge: CATR1700LoaderImageLarge,
  catr2900loaderImageLarge: CATR2900LoaderImageLarge,
  catr1600hloaderImageLarge: CATR1600HLoaderImageLarge,
  sandviklh410loaderImageLarge: SandvikLH410LoaderImageLarge,
  sandviklh411loaderImageLarge: SandvikLH411LoaderImageLarge,
  sandviklh207loaderImageLarge: SandvikLH207LoaderImageLarge,
  sandviklh514loaderImageLarge: SandvikLH514LoaderImageLarge,
  cat980mlight_truckImageLarge: CAT980MLightTruckImageLarge,
  rokionr100light_truckImageLarge: RokionR100LightTruckImageLarge,
  cat16mmiscellaneousImageLarge: CAT16MMiscellaneousImageLarge,
  cat24mmiscellaneousImageLarge: CAT24MMiscellaneousImageLarge,
  cat844hdozerImageLarge: CAT844HDozerImageLarge,
  catd10tdozerImageLarge: CATD10TDozerImageLarge,
  catd11tdozerImageLarge: CATD11TDozerImageLarge,
  cat395excavatorImageLarge: CAT395ExcavatorImageLarge,
  cat390excavatorImageLarge: CAT390ExcavatorImageLarge,
  'atlas airrocd45drillImageLarge': AtlasAirrocD45DrillImageLarge,
  'atlas airrocd65drillImageLarge': AtlasAirrocD65DrillImageLarge,
  'sandvikds-311drillImageLarge': SandvikDS311DrillImageLarge,
  'dthjk860-2drillImageLarge': DTHJK860DrillImageLarge,
  sanyskt115shaul_truckImageLarge: SanySKT115SHaulTruckImageLarge,
  hitachiex1200loaderImageLarge: HitachiEX1200LoaderImageLarge,
  'sanystg265c-10graderImageLarge': SanySTG265C10GraderImageLarge,
  sem823fdozerImageLarge: SEM823FDozerImageLarge,

  // small PNGs
  fallbackhaul_truckImageSmall: FallbackHaulTruckImageSmall,
  fallbackloaderImageSmall: FallbackLoaderImageSmall,
  cat777haul_truckImageSmall: CAT777HaulTruckImageSmall,
  'hitachieh 1700haul_truckImageSmall': HitachiE1700FHaulTruckImageSmall,
  cat740haul_truckImageSmall: CAT740HaulTruckImageSmall,
  cat745chaul_truckImageSmall: CAT745CHaulTruckImageSmall,
  cat795fhaul_truckImageSmall: CAT795FHaulTruckImageSmall,
  cat775ghaul_truckImageSmall: CAT775GHaulTruckImageSmall,
  cat777fhaul_truckImageSmall: CAT777FHaulTruckImageSmall,
  cat793fhaul_truckImageSmall: CAT793FHaulTruckImageSmall,
  'komatsuhd 1500-7haul_truckImageSmall': KomatsuHD15007HaulTruckImageSmall,
  'komatsuhd 465haul_truckImageSmall': KomatsuHD465HaulTruckImageSmall,
  'sandvikth-320haul_truckImageSmall': SandvikTH320HaulTruckImageSmall,
  catad30haul_truckImageSmall: CATAD30HaulTruckImageSmall,
  cat798achaul_truckImageSmall: CAT798ACHaulTruckImageSmall,
  cat972loaderImageSmall: CAT972LoaderImageSmall,
  cat992gloaderImageSmall: CAT992GLoaderImageSmall,
  cat992kloaderImageSmall: CAT992KLoaderImageSmall,
  cat980hloaderImageSmall: CAT980HLoaderImageSmall,
  cat980loaderImageSmall: CAT980LoaderImageSmall,
  cat990loaderImageSmall: CAT990LoaderImageSmall,
  cat993loaderImageSmall: CAT993LoaderImageSmall,
  catr1700loaderImageSmall: CATR1700LoaderImageSmall,
  catr2900loaderImageSmall: CATR2900LoaderImageSmall,
  catr1600hloaderImageSmall: CATR1600HLoaderImageSmall,
  sandviklh410loaderImageSmall: SandvikLH410LoaderImageSmall,
  sandviklh411loaderImageSmall: SandvikLH411LoaderImageSmall,
  sandviklh207loaderImageSmall: SandvikLH207LoaderImageSmall,
  sandviklh514loaderImageSmall: SandvikLH514LoaderImageSmall,
  cat980mlight_truckImageSmall: CAT980MLightTruckImageSmall,
  rokionr100light_truckImageSmall: RokionR100LightTruckImageSmall,
  cat16mmiscellaneousImageSmall: CAT16MMiscellaneousImageSmall,
  cat24mmiscellaneousImageSmall: CAT24MMiscellaneousImageSmall,
  cat844hdozerImageSmall: CAT844HDozerImageSmall,
  catd10tdozerImageSmall: CATD10TDozerImageSmall,
  catd11tdozerImageSmall: CATD11TDozerImageSmall,
  cat395excavatorImageSmall: CAT395ExcavatorImageSmall,
  cat390excavatorImageSmall: CAT390ExcavatorImageSmall,
  'atlas airrocd45drillImageSmall': AtlasAirrocD45DrillImageSmall,
  'atlas airrocd65drillImageSmall': AtlasAirrocD65DrillImageSmall,
  'sandvikds-311drillImageSmall': SandvikDS311DrillImageSmall,
  'dthjk860-2drillImageSmall': DTHJK860DrillImageSmall,
  sanyskt115shaul_truckImageSmall: SanySKT115SHaulTruckImageSmall,
  hitachiex1200loaderImageSmall: HitachiEX1200LoaderImageSmall,
  'sanystg265c-10graderImageSmall': SanySTG265C10GraderImageSmall,
  sem823fdozerImageSmall: SEM823FDozerImageSmall,
};

// Props interface
interface Props extends ImgHTMLAttributes<HTMLImageElement> {
  name?: string;
  isHovering?: boolean;
  style?: CSSProperties;
}

// PNG Component
export const PNG = ({
  name = '',
  isHovering = false,
  style,
  ...rest
}: Props): JSX.Element | null => {
  const src = images[name];
  if (!src) return null;

  return <img src={src} alt={name} style={style} {...rest} />;
};
